export default __webpack_public_path__ + "static/slideshow-2-9e7d0d8ac13a5dc83e1d5ac53e71e89f.png";